<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="notFound">
  <div class="modal-header">
    <h4 class="modal-title">Not Found</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!(serverError || notFound)">

  <div class="modal-header">
    <h4 class="modal-title">Custom Inbox Item</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body pb-0" *ngIf="loadingItem">
    <p>Loading...</p>
  </div>

  <div class="modal-body pb-0" *ngIf="!loadingItem">

    <p>
      <b>
        Customer
      </b>
      <br>
      Name:
      <a [routerLink]="['/customers', item.customer_id.toString()]"
         target="_blank">
        {{ item.customer_first_name }} {{ item.customer_last_name }}
      </a>
      <br>
      Birthday: {{ dateStringFromISO8601(item.customer_birthday) }} <br>
      Email:
      <span *ngIf="item.customer_email">{{ item.customer_email }}</span>
      <span *ngIf="!item.customer_email" class="text-muted">None</span>
    </p>

    <p>
      <b>Conditions Met</b>
      <ng-container *ngFor="let conditionMet of conditionsMetList">
        <br>
        {{ conditionMet }}
      </ng-container>
    </p>

    <p>
      Item added at
      {{ timeStringFromISO8601(item.created_at, orgConfig.getOrganizationConfig().time_zone) }},
      {{ dateStringFromISO8601(item.created_at, orgConfig.getOrganizationConfig().time_zone) }}
    </p>

    <p *ngIf="item.is_resolved">
      <ng-container *ngIf="item.resolved_by_id">
        Resolved by
        {{ getStaffNameDisplay(item.resolved_by_first_name, item.resolved_by_last_name, item.resolved_by_email) }}
      </ng-container>
      <ng-container *ngIf="!item.resolved_by_id">
        Resolved automatically
      </ng-container>
      at
      {{ timeStringFromISO8601(item.resolved_at, orgConfig.getOrganizationConfig().time_zone) }},
      {{ dateStringFromISO8601(item.resolved_at, orgConfig.getOrganizationConfig().time_zone) }}
    </p>

    <p *ngIf="!item.is_resolved && item.auto_resolve_timestamp">
      Will auto-resolve at
      {{ timeStringFromISO8601(item.auto_resolve_timestamp, orgConfig.getOrganizationConfig().time_zone) }},
      {{ dateStringFromISO8601(item.auto_resolve_timestamp, orgConfig.getOrganizationConfig().time_zone) }}
    </p>

    <div class="alert alert-info"
         *ngIf="!item.is_resolved && item.inbox_staff_instruction_text"
         [innerHtml]="getRenderedMarkdown(item.inbox_staff_instruction_text)"></div>

    <div class="alert alert-danger mb-3" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">

    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Close
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!(loadingSubmit || loadingItem) && !item.is_resolved"
            (click)="handleResolve()">
      Resolve
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit || loadingItem">
      Loading...
    </button>

  </div>

</ng-container>
